import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-flight-filters-empty-state',
  templateUrl: './flight-filters-empty-state.component.html',
  styleUrls: ['./flight-filters-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlightFiltersEmptyStateComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Output()
  clearAllFilters: EventEmitter<void> = new EventEmitter();
}
